import {AppState} from "../app.state";

export const statusSelector = (state: AppState) => state.home.status;
export const deliveryTokenSelector = (state: AppState) => state.home.deliveryTokenId;
export const deliveryDetailsSelector = (state: AppState) => state.home.deliveryDetails;
export const pickUpLatLngSelector = (state:AppState)=> state.home.pickUpLatLng;
export const deliveryLatLngSelector = (state: AppState)=> state.home.deliveryLatLng;
export const agentLatLngSelector = (state: AppState)=> state.home.agentLatLng;
export const agentImageSelector = (state: AppState)=> state.home.agentImage;
export const accountImageSelector = (state: AppState)=> state.home.accountImage;
export const orderTimeLineDetails = (state: AppState)=>state.home.orderTimeLineDetails;
export const orderDetails = (state: AppState)=>state.home.orderDetails;
export const deliveryAgent = (state: AppState) => state.home.deliveryAgentDetails;
export const polylineSelector = (state: AppState) => state.home.polyline;
export const deliveryDateTimeDetails = (state: AppState)=> state.home.deliveryDateTimeDetails
export const deliveryLocationDetails = (state: AppState) =>state.home.deliveryLocationDetails
export const ratingDetails = (state:AppState) => state.home.ratingDetails
export const successAnimationMsg = (state: AppState) => state.home.successAnimationMsg
export const etaDetails = (state: AppState) => state.home.etaDetails
export const trackData = (state: AppState) => state.home.trackData
export const orderStatus = (state: AppState) => state.home.orderStatus
export const deliveryAcknowledgeViewStatus = (state: AppState) => state.home.deliveryAcknowledgeViewStatus
export const featureVisbilityProperties = (state: AppState) => state.home.featureVisbilityProperties
export const getWarehouseOrderId = (state: AppState) => state.home.warehouseOrderId
export const checkIfOrderIdInParams = (state: AppState) => state.home.isParamOrderId
export const getOrderIdForTimeline = (state: AppState) => state.home.orderIdForTimeline
export const getDocketId = (state: AppState) => state.home.docketId
export const getOrderStatusForTimeline = (state: AppState) => state.home.orderStatusForTimeline
export const selectOrderDocuments = (state: AppState) => state.home.orderDocuments
export const pickUpLocationDetails = (state: AppState) => state.home.pickUpLocationDetails
export const loadingSelector = (state: AppState) => state.home.loading
export const apiErrorSelector = (state: AppState) => state.home.apiError
export const statusDataSelector = (state: AppState) => state.home.statusData